import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import Loader from "../../../layouts/loader/Loader";
import { htmlToText } from "html-to-text";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link } from "react-router-dom";

const Page = () => {
  const [plans, setPlan] = useState([]);
  const [total, setTotal] = useState(0);
  const [tab, setTab] = useState({ state: 1, type: "MONTHLY" });
  const [pageNum, setPageNum] = useState(1);
  const renderHTML = (rawHTML: string) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });
  const [type, setType] = useState("provider");
  const [fullContent, setFullContent] = useState("");
  const [formError, setFormError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addPlan, setAddPlan] = useState({ status: false });
  const [deletePlan, setDeletePlan] = useState({ status: false, id: null });
  const [editPlan, setEditPlan] = useState({
    status: false,
    id: null,
    name: null,
    description: "",
    cost: null,
    cost_period: null,
    job_post_limit: null,
    lead_limit: null,
    advertisement: null,
    dashboard_access: null,
  });

  const initialValues = {
    name: "",
    description: "",
    cost: "",
    cost_period: "",
    job_post_limit: "",
    lead_limit: "",
    advertisement: "",
    dashboard_access: "",
  };

  const initialEditValues = {
    name: editPlan.name ?? "",
    description: editPlan.description ?? "",
    cost: editPlan.cost ?? "",
    cost_period: editPlan.cost_period ?? "",
    job_post_limit: editPlan.job_post_limit ?? "",
    lead_limit: editPlan.lead_limit ?? "",
    advertisement: editPlan.advertisement ?? "",
    dashboard_access: editPlan.dashboard_access ?? "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Plan Name is required!"),
    description: Yup.string().required("Plan Description is required!"),
    cost: Yup.number().required("Plan Amount is required!"),
    cost_period: Yup.string().required("Plan Type is required!"),
    job_post_limit: Yup.string().required("Plan Job Post Limit is required!"),
    lead_limit: Yup.string().required("Plan Lead Limit is required!"),
    advertisement: Yup.string().required(
      "Plan Advertisement Limit is required!"
    ),
    dashboard_access: Yup.string().required(
      "Plan Dashboard Access is required!"
    ),
  });

  const getPlanList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all plans list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setPlan(response.data.data);
      setTotal(response.data.totalPages);
    } else setPlan([]);
    setLoading(false);
  };

  const addNewPlan = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      name: formValue.name,
      description: formValue.description,
      cost: formValue.cost,
      cost_period: formValue.cost_period,
      monthly_commit: formValue.cost,
      job_post_limit: formValue.job_post_limit,
      lead_limit: formValue.lead_limit,
      advertisement: formValue.advertisement,
      dashboard_access: formValue.dashboard_access,
    });
    const response = await ApiService.postAPIWithAccessToken(api.addPlan, form);
    setAddPlan({ status: false });
    if (response.data.status) {
      toast.success(response.data.message);
      getPlanList(api.planList);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const updatePlan = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      name: formValue.name,
      description: formValue.description,
      cost: formValue.cost,
      cost_period: formValue.cost_period,
      monthly_commit: formValue.cost,
      job_post_limit: formValue.job_post_limit,
      lead_limit: formValue.lead_limit,
      advertisement: formValue.advertisement,
      dashboard_access: formValue.dashboard_access,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.updatePlan + editPlan.id,
      form
    );
    setEditPlan({
      status: false,
      id: null,
      name: null,
      description: "",
      cost: null,
      cost_period: null,
      job_post_limit: null,
      lead_limit: null,
      advertisement: null,
      dashboard_access: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getPlanList(api.planList);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deletePlaneFunc = async (id) => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.deletePlan + `${id}`
    );
    setDeletePlan({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getPlanList(api.planList);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getPlanList(api.planList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="heading-title">Subscription Plan</h3>
          <div className="d-flex">
            <button
              style={{ marginLeft: "20px" }}
              type="button"
              className="btn-bl"
              onClick={() => setAddPlan({ status: true })}
            >
              Add New Plan
            </button>
          </div>
        </div>
        <div className="subscription-content">
          <div className="messages-tab">
            <ul className="nav nav-tabs">
              <li>
                <Link
                  className={tab.state == 1 ? "active" : ""}
                  onClick={() => setTab({ state: 1, type: "MONTHLY" })}
                  to=""
                  data-bs-toggle="tab"
                >
                  Monthly
                </Link>
              </li>
              <li>
                <Link
                  className={tab.state == 2 ? "active" : ""}
                  onClick={() => setTab({ state: 2, type: "QUARTERLY" })}
                  to=""
                  data-bs-toggle="tab"
                >
                  Quarterly
                </Link>
              </li>
              <li>
                <Link
                  className={tab.state == 3 ? "active" : ""}
                  onClick={() => setTab({ state: 3, type: "HALF_YEARLY" })}
                  to=""
                  data-bs-toggle="tab"
                >
                  Half Yearly
                </Link>
              </li>
              <li>
                <Link
                  className={tab.state == 4 ? "active" : ""}
                  onClick={() => setTab({ state: 4, type: "YEARLY" })}
                  to=""
                  data-bs-toggle="tab"
                >
                  Yearly
                </Link>
              </li>
            </ul>
          </div>
          {tab.state == 1 ? (
            <div className="row">
              {plans?.monthlyPlans?.length !== 0 ? (
                plans?.monthlyPlans?.map((ele, indx) => {
                  return (
                    <div key={indx} className="col-lg-4 mt-5">
                      <div
                        className="cc-subscription-card"
                        style={{ height: "600px" }}
                      >
                        <div className="cc-subscription-info">
                          <div className="cc-planname-text">
                            {ele.name ?? "NA"}
                          </div>
                        </div>
                        <div className="cc-subscription-price-info">
                          {ele.cost_period == "Featured" ? (
                            <div className="cc-plan-price-text">
                              ${ele.required_deposit ?? "0"}
                              <span className="plan-per-text"> Deposit</span>
                            </div>
                          ) : (
                            <div
                              className="cc-plan-price-text"
                              style={{ fontSize: "2.7rem" }}
                            >
                              ${ele.cost ?? 0}
                              <span className="plan-per-text">
                                /
                                {tab.state == 1
                                  ? "Month"
                                  : tab.state == 2
                                  ? "Quarter"
                                  : tab.state == 3
                                  ? "Half Year"
                                  : "Year"}
                              </span>
                            </div>
                          )}
                          <div className="cc-plan-persave-content">
                            {ele.cost_period == "Featured" ? (
                              <p className="m-0">&nbsp;</p>
                            ) : (
                              <p
                                className="m-0"
                                style={{ color: "#45b14a", fontWeight: "600" }}
                              >
                                Enjoy a {ele.free_trial ?? 0}-Day Free Trial
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="cc-subscription-point-info">
                          <div
                            className="cc-plan-point-list-admin px-3"
                            style={{ height: "360px" }}
                          >
                            {renderHTML(ele.description)}
                          </div>
                          <div className="cc-plan-action">
                            <button
                              type="button"
                              className="btn-bl"
                              onClick={() => {
                                setEditPlan({
                                  status: true,
                                  id: ele.id,
                                  name: ele.name,
                                  description: ele.description,
                                  cost: ele.monthly_commit,
                                  cost_period: ele.cost_period,
                                  job_post_limit: ele.job_post_limit,
                                  lead_limit: ele.lead_limit,
                                  advertisement: ele.advertisement.toString(),
                                  dashboard_access:
                                    ele.dashboard_access.toString(),
                                });
                                setFullContent(ele.description);
                              }}
                            >
                              Edit Plan
                            </button>
                            <button
                              type="button"
                              className="btn-re"
                              onClick={() =>
                                setDeletePlan({
                                  status: true,
                                  id: ele.id,
                                })
                              }
                            >
                              Delete Plan
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5% 0",
                  }}
                >
                  <img width={300} src={NoData} alt="" />
                </div>
              )}
            </div>
          ) : null}
          {tab.state == 2 ? (
            <div className="row">
              {plans?.quarterlyPlans?.length !== 0 ? (
                plans?.quarterlyPlans?.map((ele, indx) => {
                  return (
                    <div key={indx} className="col-lg-4 mt-5">
                      <div
                        className="cc-subscription-card"
                        style={{ height: "600px" }}
                      >
                        <div className="cc-subscription-info">
                          <div className="cc-planname-text">
                            {ele.name ?? "NA"}
                          </div>
                        </div>
                        <div className="cc-subscription-price-info">
                          {ele.cost_period == "Featured" ? (
                            <div className="cc-plan-price-text">
                              ${ele.required_deposit ?? "0"}
                              <span className="plan-per-text"> Deposit</span>
                            </div>
                          ) : (
                            <div
                              className="cc-plan-price-text"
                              style={{ fontSize: "2.7rem" }}
                            >
                              ${ele.cost ?? 0}
                              <span className="plan-per-text">
                                /
                                {tab.state == 1
                                  ? "Month"
                                  : tab.state == 2
                                  ? "Quarter"
                                  : tab.state == 3
                                  ? "Half Year"
                                  : "Year"}
                              </span>
                            </div>
                          )}
                          <div className="cc-plan-persave-content">
                            {ele.cost_period == "Featured" ? (
                              <p className="m-0">&nbsp;</p>
                            ) : (
                              <p
                                className="m-0"
                                style={{ color: "#45b14a", fontWeight: "600" }}
                              >
                                Enjoy a {ele.free_trial ?? 0}-Day Free Trial
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="cc-subscription-point-info">
                          <div
                            className="cc-plan-point-list-admin px-3"
                            style={{ height: "360px" }}
                          >
                            {renderHTML(ele.description)}
                          </div>
                          <div className="cc-plan-action">
                            <button
                              type="button"
                              className="btn-bl"
                              onClick={() => {
                                setEditPlan({
                                  status: true,
                                  id: ele.id,
                                  name: ele.name,
                                  description: ele.description,
                                  cost: ele.monthly_commit,
                                  cost_period: ele.cost_period,
                                  job_post_limit: ele.job_post_limit,
                                  lead_limit: ele.lead_limit,
                                  advertisement: ele.advertisement.toString(),
                                  dashboard_access:
                                    ele.dashboard_access.toString(),
                                });
                                setFullContent(ele.description);
                              }}
                            >
                              Edit Plan
                            </button>
                            <button
                              type="button"
                              className="btn-re"
                              onClick={() =>
                                setDeletePlan({
                                  status: true,
                                  id: ele.id,
                                })
                              }
                            >
                              Delete Plan
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5% 0",
                  }}
                >
                  <img width={300} src={NoData} alt="" />
                </div>
              )}
            </div>
          ) : null}
          {tab.state == 3 ? (
            <div className="row">
              {plans?.halfYearlyPlans?.length !== 0 ? (
                plans?.halfYearlyPlans?.map((ele, indx) => {
                  return (
                    <div key={indx} className="col-lg-4 mt-5">
                      <div
                        className="cc-subscription-card"
                        style={{ height: "600px" }}
                      >
                        <div className="cc-subscription-info">
                          <div className="cc-planname-text">
                            {ele.name ?? "NA"}
                          </div>
                        </div>
                        <div className="cc-subscription-price-info">
                          {ele.cost_period == "Featured" ? (
                            <div className="cc-plan-price-text">
                              ${ele.required_deposit ?? "0"}
                              <span className="plan-per-text"> Deposit</span>
                            </div>
                          ) : (
                            <div
                              className="cc-plan-price-text"
                              style={{ fontSize: "2.7rem" }}
                            >
                              ${ele.cost ?? 0}
                              <span className="plan-per-text">
                                /
                                {tab.state == 1
                                  ? "Month"
                                  : tab.state == 2
                                  ? "Quarter"
                                  : tab.state == 3
                                  ? "Half Year"
                                  : "Year"}
                              </span>
                            </div>
                          )}
                          <div className="cc-plan-persave-content">
                            {ele.cost_period == "Featured" ? (
                              <p className="m-0">&nbsp;</p>
                            ) : (
                              <p
                                className="m-0"
                                style={{ color: "#45b14a", fontWeight: "600" }}
                              >
                                Enjoy a {ele.free_trial ?? 0}-Day Free Trial
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="cc-subscription-point-info">
                          <div
                            className="cc-plan-point-list-admin px-3"
                            style={{ height: "360px" }}
                          >
                            {renderHTML(ele.description)}
                          </div>
                          <div className="cc-plan-action">
                            <button
                              type="button"
                              className="btn-bl"
                              onClick={() => {
                                setEditPlan({
                                  status: true,
                                  id: ele.id,
                                  name: ele.name,
                                  description: ele.description,
                                  cost: ele.monthly_commit,
                                  cost_period: ele.cost_period,
                                  job_post_limit: ele.job_post_limit,
                                  lead_limit: ele.lead_limit,
                                  advertisement: ele.advertisement.toString(),
                                  dashboard_access:
                                    ele.dashboard_access.toString(),
                                });
                                setFullContent(ele.description);
                              }}
                            >
                              Edit Plan
                            </button>
                            <button
                              type="button"
                              className="btn-re"
                              onClick={() =>
                                setDeletePlan({
                                  status: true,
                                  id: ele.id,
                                })
                              }
                            >
                              Delete Plan
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5% 0",
                  }}
                >
                  <img width={300} src={NoData} alt="" />
                </div>
              )}
            </div>
          ) : null}
          {tab.state == 4 ? (
            <div className="row">
              {plans?.yearlyPlans?.length !== 0 ? (
                plans?.yearlyPlans?.map((ele, indx) => {
                  return (
                    <div key={indx} className="col-lg-4 mt-5">
                      <div
                        className="cc-subscription-card"
                        style={{ height: "600px" }}
                      >
                        <div className="cc-subscription-info">
                          <div className="cc-planname-text">
                            {ele.name ?? "NA"}
                          </div>
                        </div>
                        <div className="cc-subscription-price-info">
                          {ele.cost_period == "Featured" ? (
                            <div className="cc-plan-price-text">
                              ${ele.required_deposit ?? "0"}
                              <span className="plan-per-text"> Deposit</span>
                            </div>
                          ) : (
                            <div
                              className="cc-plan-price-text"
                              style={{ fontSize: "2.7rem" }}
                            >
                              ${ele.cost ?? 0}
                              <span className="plan-per-text">
                                /
                                {tab.state == 1
                                  ? "Month"
                                  : tab.state == 2
                                  ? "Quarter"
                                  : tab.state == 3
                                  ? "Half Year"
                                  : "Year"}
                              </span>
                            </div>
                          )}
                          <div className="cc-plan-persave-content">
                            {ele.cost_period == "Featured" ? (
                              <p className="m-0">&nbsp;</p>
                            ) : (
                              <p
                                className="m-0"
                                style={{ color: "#45b14a", fontWeight: "600" }}
                              >
                                Enjoy a {ele.free_trial ?? 0}-Day Free Trial
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="cc-subscription-point-info">
                          <div
                            className="cc-plan-point-list-admin px-3"
                            style={{ height: "360px" }}
                          >
                            {renderHTML(ele.description)}
                          </div>
                          <div className="cc-plan-action">
                            <button
                              type="button"
                              className="btn-bl"
                              onClick={() => {
                                setEditPlan({
                                  status: true,
                                  id: ele.id,
                                  name: ele.name,
                                  description: ele.description,
                                  cost: ele.monthly_commit,
                                  cost_period: ele.cost_period,
                                  job_post_limit: ele.job_post_limit,
                                  lead_limit: ele.lead_limit,
                                  advertisement: ele.advertisement.toString(),
                                  dashboard_access:
                                    ele.dashboard_access.toString(),
                                });
                                setFullContent(ele.description);
                              }}
                            >
                              Edit Plan
                            </button>
                            <button
                              type="button"
                              className="btn-re"
                              onClick={() =>
                                setDeletePlan({
                                  status: true,
                                  id: ele.id,
                                })
                              }
                            >
                              Delete Plan
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5% 0",
                  }}
                >
                  <img width={300} src={NoData} alt="" />
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>

      <Modal
        show={addPlan.status}
        onHide={() => {
          setAddPlan({ status: false });
        }}
        className="cc-modal-form modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Add New Plan</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={addNewPlan}
              >
                {({ values, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      <div className="form-group">
                        <label htmlFor="">Plan Name</label>
                        <Field
                          type="text"
                          className="form-control todo-list-input"
                          name="name"
                          placeholder="Enter Plan Name"
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Amount</label>
                          <Field
                            type="number"
                            className="form-control todo-list-input"
                            name="cost"
                            placeholder="Enter Plan Amount"
                          />
                          <ErrorMessage
                            name="cost"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Type</label>
                          <Field
                            as="select"
                            type="text"
                            className="form-control"
                            name="cost_period"
                          >
                            <option value="">Select Plan Type</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Half Yearly">Half Yearly</option>
                            <option value="Yearly">Yearly</option>
                            <option value="Featured">Featured</option>
                          </Field>
                          <ErrorMessage
                            name="cost_period"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Lead Limit</label>
                          <Field
                            type="number"
                            className="form-control todo-list-input"
                            name="lead_limit"
                            placeholder="Enter Plan Lead Limit"
                          />
                          <ErrorMessage
                            name="lead_limit"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Job Post Limit</label>
                          <Field
                            type="number"
                            className="form-control todo-list-input"
                            name="job_post_limit"
                            placeholder="Enter Plan Job Post Limit"
                          />
                          <ErrorMessage
                            name="job_post_limit"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Advertisement</label>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="advertisement"
                                    id="Ads1"
                                    value="1"
                                  />
                                  <label for="Ads1">
                                    <span className="checkbox-text">
                                      {" "}
                                      Featured Advertisement
                                    </span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="advertisement"
                                    id="Ads0"
                                    value="0"
                                  />
                                  <label for="Ads0">
                                    <span className="checkbox-text">
                                      {" "}
                                      Un Featured Advertisement
                                    </span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="advertisement"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Dashboard Access</label>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="dashboard_access"
                                    id="Dash1"
                                    value="1"
                                  />
                                  <label for="Dash1">
                                    <span className="checkbox-text"> Yes</span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="dashboard_access"
                                    id="Dash0"
                                    value="0"
                                  />
                                  <label for="Dash0">
                                    <span className="checkbox-text"> No</span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="dashboard_access"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <CKEditor
                          editor={ClassicEditor}
                          data={values.description}
                          onReady={(editor) => {}}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setFieldValue("description", data);
                          }}
                          onFocus={(event, editor) => {}}
                        />
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="form-group text-end mb-0">
                        <button
                          type="button"
                          onClick={() => setAddPlan({ status: false })}
                          className="btn-re me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn-gr"
                          data-bs-dismiss="modal"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editPlan.status}
        onHide={() => {
          setEditPlan({
            status: false,
            id: null,
            name: null,
            description: "",
            cost: null,
            cost_period: null,
            job_post_limit: null,
            lead_limit: null,
            advertisement: null,
            dashboard_access: null,
          });
        }}
        className="cc-modal-form modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Plan</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={updatePlan}
              >
                {({ values, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      <div className="form-group">
                        <label htmlFor="">Plan Name</label>
                        <Field
                          type="text"
                          className="form-control todo-list-input"
                          name="name"
                          placeholder="Enter Plan Name"
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Amount</label>
                          <Field
                            type="number"
                            className="form-control todo-list-input"
                            name="cost"
                            placeholder="Enter Plan Amount"
                          />
                          <ErrorMessage
                            name="cost"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Type</label>
                          <Field
                            as="select"
                            type="text"
                            className="form-control"
                            name="cost_period"
                          >
                            <option value="">Select Plan Type</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Half Yearly">Half Yearly</option>
                            <option value="Yearly">Yearly</option>
                            <option value="Featured">Featured</option>
                          </Field>
                          <ErrorMessage
                            name="cost_period"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Lead Limit</label>
                          <Field
                            type="number"
                            className="form-control todo-list-input"
                            name="lead_limit"
                            placeholder="Enter Plan Lead Limit"
                          />
                          <ErrorMessage
                            name="lead_limit"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Job Post Limit</label>
                          <Field
                            type="number"
                            className="form-control todo-list-input"
                            name="job_post_limit"
                            placeholder="Enter Plan Job Post Limit"
                          />
                          <ErrorMessage
                            name="job_post_limit"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Plan Advertisement</label>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="advertisement"
                                    id="Ads1"
                                    value="1"
                                  />
                                  <label for="Ads1">
                                    <span className="checkbox-text">
                                      {" "}
                                      Featured Advertisement
                                    </span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="advertisement"
                                    id="Ads0"
                                    value="0"
                                  />
                                  <label for="Ads0">
                                    <span className="checkbox-text">
                                      {" "}
                                      Un Featured Advertisement
                                    </span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="advertisement"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="">Dashboard Access</label>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="dashboard_access"
                                    id="Dash1"
                                    value="1"
                                  />
                                  <label for="Dash1">
                                    <span className="checkbox-text"> Yes</span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="dashboard_access"
                                    id="Dash0"
                                    value="0"
                                  />
                                  <label for="Dash0">
                                    <span className="checkbox-text"> No</span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="dashboard_access"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <CKEditor
                          editor={ClassicEditor}
                          data={editPlan.description}
                          onReady={(editor) => {}}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setFieldValue("description", data);
                          }}
                        />
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="form-group text-end mb-0">
                        <button
                          type="button"
                          onClick={() =>
                            setEditPlan({
                              status: false,
                              id: null,
                              name: null,
                              type: null,
                              cost: null,
                              cost_period: null,
                              description: "",
                              job_post_limit: null,
                              lead_limit: null,
                              advertisement: null,
                              dashboard_access: null,
                            })
                          }
                          className="btn-re me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn-gr"
                          data-bs-dismiss="modal"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deletePlan.status}
        onHide={() => {
          setDeletePlan({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Subscription</h5>
                <p className="text-center">
                  This action can't be undone. Do you really want to delete
                  subscription ?
                </p>
              </div>
              <div className="form-group text-center mb-0">
                <button
                  type="button"
                  onClick={() =>
                    setDeletePlan({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deletePlaneFunc(deletePlan.id)}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
